import { useMemo } from 'react'
import { useUserContext } from '@vp/ubik-context'

import { history as galleryHistory } from 'client/utils/history'
import { transformQueryStringsToCamelCase } from '~/shared/url'

export const useSearchParams = (): URLSearchParams => {
  const { queryStrings } = useUserContext()

  const serverQuery = transformQueryStringsToCamelCase(queryStrings ?? {})
  const clientQuery = galleryHistory?.location?.search

  return useMemo(() => new URLSearchParams(clientQuery ?? serverQuery), [clientQuery])
}
